var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"secondary"},[_c('Alert'),(_vm.isLogin && _vm.showRemind)?_c('Dialog'):_vm._e(),_c('Navigation'),_c('v-content',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }